import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../environment';
import { AuthService } from '@common/services/AuthService/AuthService';
import { ProgressData } from '@common/models/progressData.model';

@Injectable()
export class ProgressService {
  constructor(
    private http: HttpClient,
    public authService: AuthService,
  ) {}

  getProgress(): Observable<ProgressData> {
    const endpoint = environment.endpoints.progress;
    const accessToken = this.authService.getAccessToken();
    const companyKey = this.authService.getCompanyKey();

    return this.http.get<ProgressData>(
      `${endpoint}${companyKey}/`,
      {
        headers: new HttpHeaders()
          .set('Authorization', `Bearer ${accessToken}`)
          .set('language', navigator.language),
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/ProgressService/ProgressService.ts